<template>
  <div class="p-4 bg-white rounded-lg h-100">
    <DataTable />
  </div>
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import {
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/picking.module";
import DataTable from "@/own/components/warehouseManagement/picking/DataTable.vue";
import Swal from "sweetalert2";

export default {
  name: "Picking",
  components: { DataTable },
  async mounted() {
    this.$store.commit(SET_PAGE_LOADING, true);
    await this.$store.dispatch(UPDATE_TABLE_STRUCTURE);

    if (!this.selectedWarehouse) {
      this.noWarehouseSelectedWarning();
      this.$store.commit(SET_PAGE_LOADING, false);
    } else {
      this.updateTableContent();
    }
  },
  computed: {
    selectedWarehouse: function () {
      return this.$store.getters.getSelectedWarehouse;
    },
  },
  methods: {
    updateTableContent() {
      this.$store
        .dispatch(UPDATE_TABLE_DATA, { warehouse_id: this.selectedWarehouse })
        .then(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    noWarehouseSelectedWarning() {
      Swal.fire({
        title: `Warning`,
        text: `Please select an warehouse to proceed with putaway tasks.`,
        icon: "warning",
        showConfirmButton: true,
      });
    },
  },
  watch: {
    selectedWarehouse() {
      if (this.selectedWarehouse) {
        this.updateTableContent();
      }
    },
  },
};
</script>
